import { render } from "./recut-new.vue?vue&type=template&id=09ffc611&scoped=true"
import script from "./recut-new.vue?vue&type=script&lang=js"
export * from "./recut-new.vue?vue&type=script&lang=js"

import "./recut-new.vue?vue&type=style&index=0&id=09ffc611&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ffc611"]])

export default __exports__